
<style lang="scss">
    .selectupload .ivu-select-dropdown{
        width:326px !important;
    }
</style>
<template>
    <vForm :label-width="120" inline class="selectupload">
        <compFormEdit
            ref="formdata"
            class="margin-10"
            v-if="getBase&&getBase.length"
            :formdata="getBase"
            v-model="formData"
        ></compFormEdit>
        <compUpload v-bind="getFileProps" @on-close="close" @on-success="success" @on-error="error" :warningtitle="warningtitle"></compUpload>
        
    </vForm>
</template>
<script>
import { mapGetters } from "vuex";

export default {
    props:{
        name: String, 
        formdata: Array,
        actionurl: String,
        downrul: String,
        warningtitle: String, 
        localurl:Boolean,
        showdownload:Number,
        params:null,
    },
    data(){
        return {
            formData:{...this.params},
        }
    },
    components: {
        compFormEdit: () => import("./formedit"),
		compUpload: () => import("./upload"),
	},
    computed: {
        getBase(){
            return this.formdata
        },
        getFileProps() {
            if(this.showdownload === 1){
                return {
                    action: this.actionurl,
                    name: this.name,
                    data: {
                        ...this.formData
                    },
                }
            }else{
                return {
                    action: this.actionurl,
                    name: this.name,
                    data: {
                        ...this.formData
                    },
                    download:()=>{
                        if(this.localurl){
                            this.handleWebfs(this.downrul, {}, {
                                executor: 'download',
                                type: 'url'
                            });
                        }else{
                            this.handleWebfs(this.downrul, 'download')    
                        }
                    }
                }
            }
			
		},
    },
    methods: {
        close(){
            this.$emit('on-close')
        },
        success(res){
            // this.$VMessage.success(res.message);
            this.close()
            this.$emit('on-update')
        },
        error(mesg){
            this.$emit('on-error',mesg)
        }
    }
}
</script>